/**
 * TanStack Query client configuration.
 *
 * Query keys in this app (defined in the hooks that use them):
 * - ['currentUser'] — AuthContext (current user when token exists)
 * - ['trips', page, size] — paginated trip list (useTripsQueries)
 * - ['trip', id] — single trip by id (useTripsQueries)
 * - ['health'] — server health (useHealthQuery)
 *
 * Caching / staleness: default staleTime is 1 minute. For that 1 minute the data is "fresh" and
 * will not refetch on mount or focus. After 1 minute it becomes "stale"; the next time a component
 * uses that query it will refetch in the background. refetchOnWindowFocus is false so returning to
 * the tab does not trigger a refetch (avoids visible re-render). Mutations (create/update/delete trip, logout)
 * call invalidateQueries so affected cache entries are marked stale immediately and refetched when used.
 *
 * Benefits: deduplication by key (one request per key, no Strict Mode duplicates), shared cache,
 * built-in loading/error and retries. This client is provided at app root via QueryClientProvider.
 */
import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1 * 60 * 1000, // 1 minute — fresh until then; after that, refetch on next use
      retry: 1,
      refetchOnWindowFocus: false, // avoid visible re-render when user returns to the tab
    },
  },
});
